module.exports = __webpack_public_path__ + "static/media/close_icon.66d116ee.svg";